import { GlobalNavigationContainer } from './global-navigation/GlobalNavigationContainer'
import { Outlet, ScrollRestoration } from 'react-router'
import { observer } from 'mobx-react-lite'
import { Suspense } from 'react'
import { LoadingPage } from '@/components/LoadingPage'
import { TermsOfUseAcceptanceDialogContainer } from '@/features/account/terms/TermsOfUseAcceptanceDialog/TermsOfUseAcceptanceDialogContainer'
import { DocumentDialogsHost } from '@/features/docs/DocumentDialogsHost'
import { TaxProfileDialogsHost } from '@/features/tax-profile/TaxProfileDialogsHost'
import { JobDialogsHost } from '@/features/jobs/JobDialogsHost'
import { HandoffDialogContainer } from '@/features/shell/handoff/HandoffDialog/HandoffDialogContainer'
import { Section7216AcceptanceDialogContainer } from '@/features/account/section-7216/Section7216AcceptanceDialog/Section7216AcceptanceDialogContainer'

export default observer(function ShellContainer() {
  return (
    <GlobalNavigationContainer>
      <ScrollRestoration />

      <Suspense fallback={<LoadingPage full />}>
        <Outlet />
      </Suspense>

      <Suspense fallback={<></>}>
        <HandoffDialogContainer />
        <TermsOfUseAcceptanceDialogContainer />
        <Section7216AcceptanceDialogContainer />
        <DocumentDialogsHost />
        <TaxProfileDialogsHost />
        <JobDialogsHost />
      </Suspense>
    </GlobalNavigationContainer>
  )
})
